import { CompanyModel } from 'models/CompanyModel';
import { CarModel } from 'models/StockModel';
import { YardModel } from 'models/YardModel';


export enum TransportationStatus {
    NonAssigned = 'non_assigned',
    Pending = 'pending',
    InTransit = 'in_transit',
    Delivered = 'delivered',
    Canceled = 'canceled',
    Lost = 'lost',
}

export type TransportationModel = {
    id: number,
    status: TransportationStatus,
    agent: CompanyModel,
    car: CarModel,
    from: YardModel,
    to: YardModel,
    orderId: number,
    price: number,
    note: string,
    order: {
        id: number,
        price: number,
    }
}
